
import {
  RevHorizontalSeriesBlock,
  RevHorizontalSeriesBlockItem,
  icons,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { PAYMENT_ADVERTISING_TYPES } from '@payment'

import {
  deliveryItem,
  paymentItem,
  satisfactionItem,
  warrantyItem,
} from '../../helpers/trust'

export default {
  components: {
    RevHorizontalSeriesBlockItem,
    RevHorizontalSeriesBlock,
  },
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        Object.values(PAYMENT_ADVERTISING_TYPES).includes(value),
    },
    ratings: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
      paymentMethods: 'countryConfig/paymentMethods',
      warrantyDuration: 'config/warrantyDuration',
    }),
  },

  created() {
    this.payment = this.createItemFrom(this.getPaymentItem())
    this.satisfaction = this.createItemFrom(this.getSatisfactionItem())
    this.delivery = this.createItemFrom(this.getDeliveryItem())
    this.warranty = this.createItemFrom(this.getWarrantyItem())
  },

  methods: {
    iconComponent: (icon) => {
      return icons[icon]
    },
    isIconFromDS(icon) {
      return icon in icons
    },
    getStickerProps({ icon }) {
      return this.isIconFromDS(icon)
        ? { icon: this.iconComponent(icon) }
        : { imageSrc: this.$static(icon) }
    },
    getPaymentItem() {
      return paymentItem({
        paymentAdvertisingType: this.variant,
        paymentMethods: this.paymentMethods,
        ratings: this.ratings,
      })
    },
    getSatisfactionItem() {
      return satisfactionItem({ days: this.coolingOffDays })
    },
    getDeliveryItem() {
      return deliveryItem()
    },
    getWarrantyItem() {
      return warrantyItem({
        warrantyDuration: this.warrantyDuration,
      })
    },
    getItemTranslation(item) {
      const {
        i18n: { translation, params = {} },
      } = item

      return this.$t(translation, params)
    },
    createItemFrom(item) {
      return {
        id: item.id,
        icon: item.icon,
        text: this.getItemTranslation(item),
      }
    },
  },
}
